import moment from "moment";

export const getUnixTimeFromDate = (date) => {
  if (!date) {
    return moment().utc().set({ hour: 0, m: 0, s: 0, ms: 0 }).unix();
  }
  return moment(date).utc().set({ hour: 0, m: 0, s: 0, ms: 0 }).unix();
};
